import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import TeacherPage from "./pages/TeacherPage";
import StudentPage from "./pages/StudentPage";
import TeacherView from "./pages/TeacherView";
import AdminPage from "./pages/AdminPage";
import ChangelogPage from "./pages/ChangelogPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import ImpressumPage from "./pages/ImpressumPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<TeacherPage />} />
        <Route path="/liste/:id" element={<StudentPage />} />
        <Route path="/lehrer/:id/:secret" element={<TeacherView />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/changelog" element={<ChangelogPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
        <Route path="/impressum" element={<ImpressumPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
